import { Controller } from "@hotwired/stimulus"

// Greys out booking hours already at capacity for the selected city + date
// (capacity = photographers covering the city — see Shooting.full_hours_for).
// Attached to each booking <form>; listens to the city select and the
// flatpickr date input, both of which fire native change events. Best-effort
// UX only: the model validation + slot lock re-check on submit, so a slot
// taken after this ran still gets a clean error instead of a double booking.
export default class extends Controller {
  static values = { url: String, categoryId: Number }

  connect() {
    this.cityField = this.element.querySelector('select[name="city"]')
    this.dateField = this.element.querySelector("input.datebriefpicker")
    this.refresh = this.refresh.bind(this)
    this.cityField?.addEventListener("change", this.refresh)
    this.dateField?.addEventListener("change", this.refresh)
    this.refresh()
  }

  disconnect() {
    this.cityField?.removeEventListener("change", this.refresh)
    this.dateField?.removeEventListener("change", this.refresh)
  }

  async refresh() {
    const city = this.cityField?.value
    const date = this.dateField?.value
    if (!city || !date) return this.apply([])

    const params = new URLSearchParams({ city, date })
    if (this.categoryIdValue) params.set("category_id", this.categoryIdValue)

    try {
      const response = await fetch(`${this.urlValue}?${params}`, { headers: { Accept: "application/json" } })
      if (!response.ok) return
      const data = await response.json()
      this.apply(data.full_hours || [])
    } catch {
      // Network hiccup — leave hours enabled; the server re-checks on submit.
    }
  }

  apply(fullHours) {
    const full = new Set(fullHours)

    // Hour pills — partner form styles a <span> inside the label
    // (.uber-hour-pill); the generic form styles the label itself
    // (.booking-hour-pill). Grey out whichever is the visible element.
    this.element.querySelectorAll('input[type="radio"][name="shooting[hour]"]').forEach((radio) => {
      const isFull = full.has(radio.value)
      radio.disabled = isFull
      if (isFull && radio.checked) radio.checked = false
      const label = radio.closest("label")
      const pill = label?.classList.contains("booking-hour-pill") ? label : label?.querySelector(".uber-hour-pill")
      if (pill) {
        pill.style.opacity = isFull ? "0.35" : ""
        pill.style.textDecoration = isFull ? "line-through" : ""
        pill.style.pointerEvents = isFull ? "none" : ""
        pill.title = isFull ? "Horario no disponible en esta ciudad" : ""
      }
    })

    // Mobile — hour <select>
    const select = this.element.querySelector('select[name="shooting[hour]"]')
    if (select) {
      Array.from(select.options).forEach((option) => {
        if (option.value) option.disabled = full.has(option.value)
      })
      if (select.value && full.has(select.value)) select.value = ""
    }
  }
}
